import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bbab9de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "none"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No tasks yet, why not ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("add a task")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("? ")
const _hoisted_6 = {
  key: 1,
  class: "list-wrapper"
}
const _hoisted_7 = { class: "cc-toolbar" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "add_task", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Add task ")
const _hoisted_10 = {
  key: 0,
  class: "item-info"
}
const _hoisted_11 = {
  key: 0,
  class: "none"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" No mentions, mention this center in any task with ")
const _hoisted_13 = { class: "app-copy-text" }
const _hoisted_14 = {
  key: 1,
  class: "list-wrapper"
}
const _hoisted_15 = {
  key: 0,
  class: "item-info"
}
const _hoisted_16 = {
  key: 0,
  class: "none"
}
const _hoisted_17 = {
  key: 1,
  class: "list-wrapper"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" — ")
const _hoisted_19 = {
  key: 0,
  class: "item-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppBadge = _resolveComponent("AppBadge")!
  const _component_StringLinkList = _resolveComponent("StringLinkList")!
  const _component_StringLinkInfo = _resolveComponent("StringLinkInfo")!
  const _component_o_tab_item = _resolveComponent("o-tab-item")!
  const _component_AppDateTime = _resolveComponent("AppDateTime")!
  const _component_o_tabs = _resolveComponent("o-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_o_tabs, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
      expanded: false,
      size: "large",
      position: "centered",
      animated: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_tab_item, {
          value: "tasks",
          label: `Tasks (${_ctx.tasks ? _ctx.tasks.length : 0})`
        }, {
          default: _withCtx(() => [
            (!_ctx.tasks.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_router_link, {
                    to: `/cc/${_ctx.center.dbid}/task/-1`
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _hoisted_5
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: `/cc/${_ctx.center.dbid}/task/-1`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (item, hIdx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.dbid
                      }, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_AppBadge, {
                            priority: item.priority
                          }, null, 8, ["priority"]),
                          _createVNode(_component_StringLinkList, {
                            list: _ctx.processLine(`@${item.refid} ${item.title}`),
                            highlight: [],
                            onLinkClick: ($event: any) => (_ctx.showTask($event, hIdx))
                          }, null, 8, ["list", "onLinkClick"])
                        ]),
                        (_ctx.currentInfo && _ctx.currentTaskIdx === hIdx)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_StringLinkInfo, {
                                str: _ctx.currentInfo,
                                highlight: [],
                                onItemClick: ($event: any) => (_ctx.showTask($event, hIdx))
                              }, null, 8, ["str", "onItemClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_o_tab_item, {
          value: "mentions",
          label: `Mentions (${_ctx.mentions ? _ctx.mentions.length : 0})`
        }, {
          default: _withCtx(() => [
            (!_ctx.mentions.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, "@" + _toDisplayString(_ctx.center.dbid), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mentions, (item, hIdx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.dbid
                      }, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_AppBadge, {
                            priority: item.priority
                          }, null, 8, ["priority"]),
                          _createVNode(_component_StringLinkList, {
                            list: _ctx.processLine(`@${item.dbid} ${item.title}`),
                            highlight: [`${this.center.dbid}`],
                            onLinkClick: ($event: any) => (_ctx.showMention($event, hIdx))
                          }, null, 8, ["list", "highlight", "onLinkClick"])
                        ]),
                        (_ctx.currentInfo && _ctx.currentMentionIdx === hIdx)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_StringLinkInfo, {
                                str: _ctx.currentInfo,
                                highlight: [`${this.center.dbid}`],
                                onItemClick: ($event: any) => (_ctx.showMention($event, hIdx))
                              }, null, 8, ["str", "highlight", "onItemClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_o_tab_item, {
          value: "actions",
          label: `Actions (${_ctx.historyItems ? _ctx.historyItems.length : 0 })`
        }, {
          default: _withCtx(() => [
            (!_ctx.historyItems || !_ctx.historyItems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, " No activity "))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyItems, (item, hIdx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.dbid
                      }, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_AppBadge, {
                            priority: item.priority
                          }, null, 8, ["priority"]),
                          _createVNode(_component_AppDateTime, {
                            dt: item.timestamp
                          }, null, 8, ["dt"]),
                          _hoisted_18,
                          _createVNode(_component_StringLinkList, {
                            list: _ctx.processLine(item.summary),
                            highlight: [],
                            onLinkClick: ($event: any) => (_ctx.showInfo($event, hIdx))
                          }, null, 8, ["list", "onLinkClick"])
                        ]),
                        (_ctx.currentInfo && _ctx.currentHistoryIdx === hIdx)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode(_component_StringLinkInfo, {
                                str: _ctx.currentInfo,
                                highlight: [],
                                onItemClick: ($event: any) => (_ctx.showInfo($event, hIdx))
                              }, null, 8, ["str", "onItemClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}